module.exports = __webpack_public_path__ + "img/pundong.d0b5e623.svg";